import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {addLotePagos, getLotePagosById, getLotesPagos} from '../../services';
import {ILotePagos, ILotesPagosFilter, ILotesPagosRes, ILotesPagosState} from "../types/ILotesPagos";
import {AppState} from "./rootReducer";

const initialState: ILotesPagosState = {
    status: "idle"
}

export const mostrarLotesPagos = createAsyncThunk(
    'mostrarLotesPagos', async (params:ILotesPagosFilter|undefined, thunkAPI ) => {
        const {lotesPagos} = thunkAPI.getState() as AppState;
        let paramsFilter = params || lotesPagos.filtered;

        const response = await getLotesPagos(paramsFilter)
        return {data: response.data as ILotesPagosRes, params: response.config.params}
    }
)
export const agregarLotePagos = createAsyncThunk(
    'LotePagos/agregar', async (lotePagos: ILotePagos, thunkAPI) => {
        const response = await addLotePagos(lotePagos);
        return {data: response.data};
    }
);
export const mostrarLotePagosById = createAsyncThunk(
    'mostrarLotePagosById', async (loteId:number,thunkAPI) => {
        // let byId = (thunkAPI.getState() as AppState)?.clientes?.list?.items?.find(c=>c.id === id);
        // if(byId){
        //     return {data: byId}
        // }

        const response = await getLotePagosById(loteId);
        return {data: response.data as ILotePagos}
    }
)


const slice = createSlice({
    name: 'mostrarLotesPagos',
    initialState,
    reducers: {
    },
    extraReducers: builder => {
        //--mostrarLotesPagos
        builder.addCase(mostrarLotesPagos.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarLotesPagos.fulfilled, (state,action ) => {
            state.status = "idle";
            state.filtered = action.payload.params;
            state.list = action.payload.data;
        })
        builder.addCase(mostrarLotesPagos.rejected, (state ) => {
            state.status = "idle";
        })

        //--agregarLotePagos
        builder.addCase(agregarLotePagos.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(agregarLotePagos.fulfilled, (state,action ) => {
            state.status = "idle";
            state.byId = action.payload.data;
        })
        builder.addCase(agregarLotePagos.rejected, (state ) => {
            state.status = "idle";
        })

        //--mostrarLotePagosById
        builder.addCase(mostrarLotePagosById.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarLotePagosById.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list?.items.filter(e => e.id !== action.payload.data.id);
                state.list.items.unshift(action.payload.data);
            }
        })
    }
});

export default slice.reducer;
